import { FuncResponse, FuncResponseType, FunctionBase, } from "../../storyV2/function/FunctionBase";
import { ProteinModel } from "../../storyV2/model/ProteinModel";
import { FunctionUtil } from "../../storyV2/function/FunctionUtil";
export class ProteinFunction extends FunctionBase {
    async run(input, identityInfo, variableList = [], page = 1) {
        const apiRes = await this.brainClient.openAi.alphafold(input, FunctionUtil.createAbortUuid(identityInfo));
        const entryId = apiRes.data.data.items[0].entryId;
        return new FuncResponse(FuncResponseType.PROTEIN, new ProteinModel("protein", entryId));
    }
}
